// extracted by mini-css-extract-plugin
export default {"containerMargin":"legislation_code_content-module__containerMargin--2Jxbp","errorMsg":"legislation_code_content-module__errorMsg--2l42V"};